import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Loader2, MailCheck } from "lucide-react";
import { motion } from "framer-motion";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "Si un compte existe pour cette adresse, un e-mail de réinitialisation a été envoyé.");
      setDone(true);
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center sky-bg p-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Card className="bg-white p-8 rounded-2xl border-0 shadow-2xl">
          <div className="mb-6 flex justify-center"><img src="/inzeair-logo.jpg" alt="InZeAir" className="w-36 rounded-xl" /></div>
          {!done ? (
            <>
              <h2 className="font-display font-bold text-2xl text-slate-900">Mot de passe oublié</h2>
              <p className="text-sm text-slate-500 mb-6">Saisissez l'adresse e-mail de votre compte. Nous vous enverrons un lien de réinitialisation.</p>
              <form onSubmit={submit} className="space-y-4">
                <div className="grid gap-1.5">
                  <label className="text-sm font-medium text-slate-600">Adresse e-mail</label>
                  <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="vous@exemple.com" />
                </div>
                {error && <div data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>}
                <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full rounded-full h-11">
                  {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4" data-testid="forgot-success">
              <MailCheck className="h-12 w-12 text-primary mx-auto mb-4" />
              <p className="text-slate-700">{msg}</p>
            </div>
          )}
          <div className="text-center mt-6">
            <Link to="/login" className="text-sm text-primary hover:underline">Retour à la connexion</Link>
          </div>
        </Card>
      </motion.div>
    </div>
  );
}
